import styled from 'styled-components';

const MyDiv = styled.div`
  .holiday-wrapper {
    width: 410px;
    height: auto;
    background-color: #F0F5F1;
  }

  .holiday-list {
    max-height: 280px; 
    overflow-y: auto;
    padding-right: 6px; 
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
    transition: scrollbar-color 0.3s ease-in-out;
  }

  .holiday-list:hover {
    scrollbar-color: gray #eae6e6ff;
  }

  .holiday-list::-webkit-scrollbar {
    width: 6px;
  }

  .holiday-list::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 6px;
    transition: background 0.3s ease-in-out;
  }

  .holiday-list:hover::-webkit-scrollbar-thumb {
    background: transparent;  
  }

  .holiday-list::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 6px;
  }

  .holiday-row {
    background-color: #ffffff;
    border-radius: 4px;
    padding: 4px 4px 4px 9px;
    margin-bottom: 9px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  }

  .date-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid #e2e8f0;
    border-radius: 3px;
    padding: 4px 8px;
    width: 35px;
    height: 39px;
    background-color: #fff;
  }

  .month {
    font-size: 9px;
    color: #e53e3e;
  }

  .day {
    color: #1a202c;
  }

  .holiday-date {
    font-size: 9px;
    color: gray;
  }
`;


export default MyDiv;
